import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "message" }
const _hoisted_4 = { class: "close-button-container" }
const _hoisted_5 = ["data-testid"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isVisible)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "overlay",
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.dismissPopup && _ctx.dismissPopup(...args)))
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["popup", _ctx.popupClass])
        }, [
          (_ctx.addCloseIcon)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "popup-close-btn",
                onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.dismissPopupCloseBtn && _ctx.dismissPopupCloseBtn(...args)), ["stop"]))
              }, [
                _createElementVNode("img", {
                  src: _ctx.closeSmallBlackIcon,
                  alt: "Close"
                }, null, 8, _hoisted_1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.imageSrc)
            ? (_openBlock(), _createElementBlock("img", {
                key: 1,
                src: _ctx.imageSrc,
                alt: "Popup image",
                class: "popup-image"
              }, null, 8, _hoisted_2))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_3, [
            _renderSlot(_ctx.$slots, "default", {}, undefined, true)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              class: "primary",
              style: _normalizeStyle(_ctx.buttonColor ? { '--btn-bg': _ctx.buttonColor } : {}),
              onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closePopup && _ctx.closePopup(...args)), ["stop"]))
            }, _toDisplayString(_ctx.closeButtonText), 5),
            (_ctx.bottomLinkText)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: _normalizeClass(["popup-bottom-link secondary", { 'popup-bottom-link-highlight': _ctx.bottomLinkHighlight }]),
                  "data-testid": _ctx.bottomLinkTestId || undefined,
                  onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.bottomLinkHandler && _ctx.bottomLinkHandler(...args)), ["stop"]))
                }, _toDisplayString(_ctx.bottomLinkText), 11, _hoisted_5))
              : _createCommentVNode("", true)
          ])
        ], 2)
      ]))
    : _createCommentVNode("", true)
}